import { concat, filter, includes, isEmpty, sortBy, values } from "lodash";
import { NODE_TYPES } from "src/components/NodeVisualizer/consts";
import { createCollectionNode, createEdge, createNode } from "./shared";

export const getDirectTeamCollectionId = (teamId) => {
  return `${teamId}_direct_teams`;
};

export const initializeTeamNodesAndEdges = (state = {}) => {
  const { expandedNodes } = state;

  const teams = values(state.teams);
  if (isEmpty(teams)) {
    return { nodes: [], edges: [] };
  }

  const nodes = [];
  const edges = [];
  const collectionNodes = {};

  teams.forEach((team) => {
    const isExpanded = expandedNodes.includes(team.id);
    const hasChildren = !!team.directChildTeamCount;
    const childTeams = filter(
      teams,
      (t) => t.directParentId === team.id || includes(t.diffIds, team.id)
    );
    const isLoading = !!team.childTeamsLoadingCount;
    const hasParent = !!teams.find((t) => t.id === team.directParentId);

    // wont be in a collection?
    if (isExpanded) {
      // make node and add
      const node = createNode(team.id, team, NODE_TYPES.GROUP_NODE);
      nodes.push(node);

      // has parent?
      if (hasParent) {
        // make edge to parent and add
        edges.push(createEdge(team.directParentId, node.id));
      }

      // needs a collection?
      if (hasChildren && (childTeams.length > 0 || isLoading)) {
        // create collection
        const collection = createCollectionNode(
          getDirectTeamCollectionId(team.id),
          `${team.directChildTeamCount} Teams`,
          {
            teamId: team.id,
            itemsCount: childTeams.length ?? 0,
            itemsMax: team.directChildTeamCount ?? 0,
            itemsLoading: team.childTeamsLoadingCount ?? 0,
            loadingType: NODE_TYPES.GROUP_NODE,
          }
        );

        // add collection
        collectionNodes[team.id] = collection;
        edges.push(createEdge(team.id, collection.id));

        // iter child teams
        childTeams.forEach((childTeam) => {
          // child belongs in collection?
          if (!expandedNodes.includes(childTeam.id)) {
            // make node and add to collection
            collection.data.items.push(
              createNode(
                childTeam.id,
                childTeam,
                NODE_TYPES.GROUP_NODE,
                team.id
              )
            );
          }
        });

        // sort children
        collection.data.items = sortBy(collection.data.items, "data.name");

        // HELP-10157: Hide fully loaded empty child team collection nodes.
        if (
          collection.data.itemsCount >= collection.data.itemsMax &&
          collection.data.items.length === 0
        ) {
          collection.data.hidden = true;
        }
      }
    }
  });

  const allNodes = concat(nodes, values(collectionNodes));

  // sort so collections are on the left?
  const sortedNodes = sortBy(allNodes, (node) =>
    node.type === "collection-node" ? 0 : 1
  );

  return {
    nodes: sortedNodes,
    edges,
  };
};
